import ABCyaPhaser from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData, { GameVersions, GAME_IMAGES_KEY } from '../gameData';
import UIAssetKeys from '../UIAssetKeys';
import NumberSelectButton from './NumberSelectButton';

export default class GameOverOverlay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.title = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._GameOverHeader, this).setOrigin(0);

    this.lblScore = ABCyaPhaser.Text.addText(this.scene.scale.width / 2, 0, '42pt', gameData.fontColor, FontKeys._cf_samurai_bobregular, 'SCORE', this).setOrigin(0.5,0);

    this.lblBestScore = ABCyaPhaser.Text.addText(this.scene.scale.width / 2, 0, '42pt', gameData.fontColor, FontKeys._cf_samurai_bobregular, '..', this).setOrigin(0.5,0);

    this.lblPercentCorrect = ABCyaPhaser.Text.addText(this.scene.scale.width / 2, 0, '42pt', gameData.fontColor, FontKeys._cf_samurai_bobregular, '.', this).setOrigin(0.5,0);

    this.lblPlayAgain = ABCyaPhaser.Text.addText(this.scene.scale.width / 2, 0, '56pt', gameData.fontColor, FontKeys._cf_samurai_bobregular, 'PLAY AGAIN', this).setOrigin(0.5,0);

    this.btnOptions = [];
    this.btnContainer = this.scene.add.container();
    const buttons = gameData.PLAY_BUTTONS;
    const len = buttons.length;

    if (len === 0) { // multiples array will be empty
      const numberOptions = ABCyaLib.Environment.instance.gameConfig.options;
      if (numberOptions === null) {
        let curX = 80; const xOffset = 80; const yOffset = 80; let curCol = 1;
        for (let i = 0; i < 12; i++) {
          if (i === 5) {
            curCol = 2;
            curX = 0;
          }
          const btn = new NumberSelectButton(this.scene, i + 2);
          btn.x = curX;
          btn.y = yOffset * (curCol - 1);
          curX += xOffset;
          btn.optionID = i + 2;
          btn.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onClickOptionButton(btn), this);
          this.btnContainer.add(btn);
        }
      }
      else {
        let curX = 0; const xOffset = 80;
        for (let i = 0; i < numberOptions.length; i++) {
          const btn = new NumberSelectButton(this.scene, numberOptions[i]);
          btn.x = curX;
          btn.y = 0;
          curX += xOffset;
          btn.optionID = numberOptions[i];
          btn.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onClickOptionButton(btn), this);
          this.btnContainer.add(btn);
        }
        this.btnContainer.x = 0;
      }
    }
    else {
      let curX = 0;
      for (let i = 0; i < len; i++) {
        const item = ABCyaPhaser.Images.addImage(curX, 0, `Btn${buttons[i]}`,this.btnContainer, GAME_IMAGES_KEY).setOrigin(0)
          .setInteractive();
        item.optionID = buttons[i];
        if (ABCyaLib.Environment.instance.gameConfig.senderID) item.optionID = ABCyaLib.Environment.instance.gameConfig.senderID;
        item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onClickOptionButton(item), this);
        this.btnOptions.push(item);
        curX += item.width + 80;
      }
    }

    this.add(this.btnContainer);

    this.layoutRatio();
  }

  /**
   * 
   * @param {{optionID: string}} sender 
   */
  onClickOptionButton (sender) {
    if (gameData.gameVersion === GameVersions.Multiples) {
      if (sender.optionID !== gameData.gameMode) {
        if (sender.optionID === 13) {
          gameData.gameMode = Phaser.Math.Between(2,12);
        }
        else {
          gameData.gameMode = sender.optionID;
        }
      }
      else {
        gameData.gameMode = sender.optionID;
      }
    }
    else {
      gameData.gameMode = sender.optionID;
    }
    this.emit('PLAY_AGAIN_CLICK');
  }

  layoutRatio () {
    this.title.scale = 1;
    this.title.x = this.scene.scale.width / 2 - this.title.width / 2;
    this.lblScore.y = this.title.height + this.title.y + 30;
    this.lblBestScore.y = this.lblScore.y + 70;

    this.lblPercentCorrect.y = this.lblBestScore.y + 90;

    this.btnContainer.x = this.scene.scale.width / 2 - this.btnContainer.getBounds().width / 2;
    const btnpad = 90;
    this.btnContainer.y = this.scene.scale.height - this.btnContainer.getBounds().height - btnpad;
    this.lblPlayAgain.y = this.btnContainer.y - 105;
  }

  setScores (score, percent) {
    this.lblScore.text = `SCORE ${score}`;

    this.lblBestScore.text = `BEST SCORE ${gameData.bestScore}`;

    this.lblPercentCorrect.text = `PERCENT CORRECT ${percent}`;
  }
}